import type { TestPlayer } from '../../lib/api/operatorConsole';

// Mirrors the backend rule (`allowed_created_by: %i[operator]`): the partner
// may only lift marks it placed itself. Ours stay, so an account we excluded
// after a review cannot be returned to GGR from the console.
export function canLiftMark(player: TestPlayer): boolean {
  return player.added_by === 'operator';
}
